import { render, staticRenderFns } from "./NovaSor.vue?vue&type=template&id=3a1af350"
import script from "./NovaSor.vue?vue&type=script&lang=js"
export * from "./NovaSor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports